export const DEFAULT_FORM_DATA = {
  brandCore: {
    name: '',
    mission: '',
    vibeKeywords: ['', '', '']
  },
  visuals: {
    colorSeed: '#818cf8',
    colorMode: 'light',
    fontStyle: 'sans'
  },
  scales: {
    minimalistDense: 50,
    playfulSerious: 50,
    safeExperimental: 50
  },
  _hp: ''
};

export const SCALE_LABELS = {
  minimalistDense: { low: 'Minimalist', high: 'Information Dense' },
  playfulSerious: { low: 'Playful', high: 'Serious' },
  safeExperimental: { low: 'Safe / Familiar', high: 'Experimental / Bold' }
};

export const FONT_MAP = {
  serif: "'DM Serif Display', Georgia, 'Times New Roman', serif",
  sans: "'Outfit', system-ui, sans-serif",
  mono: "'JetBrains Mono', 'Fira Code', monospace",
  display: "'Playfair Display', 'Georgia', serif",
  rounded: "'Nunito', 'Varela Round', sans-serif",
  elegant: "'Cormorant Garamond', 'Garamond', serif"
};

export const COLOR_PRESETS = [
  { name: 'Indigo', value: '#818cf8' },
  { name: 'Violet', value: '#a78bfa' },
  { name: 'Rose', value: '#fb7185' },
  { name: 'Amber', value: '#fbbf24' },
  { name: 'Emerald', value: '#34d399' },
  { name: 'Cyan', value: '#22d3ee' },
  { name: 'Coral', value: '#f97316' },
  { name: 'Slate', value: '#64748b' }
];

export const WIZARD_STEPS = [
  { id: 0, title: 'Brand Core', description: 'Define your brand identity' },
  { id: 1, title: 'Visuals', description: 'Choose your visual style' },
  { id: 2, title: 'Scales', description: 'Fine-tune the feel' },
  { id: 3, title: 'Review', description: 'Confirm your choices' }
];
